/**
 * @voltxampere/ui — Inductor (Bobin) · IEC 4-bump coil
 *
 * Quadratic Bezier humps trace a coil between x=8 and x=32. Each
 * hump rises ~8 units above the y=13 axis to give a clear silhouette
 * at typical canvas zoom levels.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const inductor = {
    id: "inductor",
    nameTr: "Bobin",
    nameEn: "Inductor",
    shortcut: "L",
    category: "passive",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, polarity: "bi" },
        { x: 40, y: 13, polarity: "bi" },
    ],
    defaultLabel: "L",
    defaultValue: "1mH",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="8" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<path d="M 8 13 Q 11 5, 14 13 Q 17 5, 20 13 Q 23 5, 26 13 Q 29 5, 32 13" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="32" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=inductor.js.map